export function formatContent(content, translate, localPath) {
  // Verifica si content es un objeto con una propiedad 'text' o si es un string directamente
  let textKey;
  if (typeof content === 'object' && content !== null) {
    textKey = content.text || ''; // Toma el texto del objeto si existe
  } else if (typeof content === 'string') {
    textKey = content; // Si es un string, úsalo directamente
  } else {
    return ''; // Si no es válido, devuelve una cadena vacía
  }

  if (!textKey || textKey.trim() === '') {
    return '';
  }

  // Traducción
  let translatedText;
  try {
    // Verificar si la clave existe antes de traducir
    if (typeof translate === 'function') {
      translatedText = translate(textKey, {
        email: '<a href="mailto:support@tradeview.eu">support@tradeview.eu</a>',
        phone: '<a href="tel:+35620311017">+356 20311017</a>',
      });
    } else {
      return textKey; // Si no hay función de traducción, devolver el texto original
    }
  } catch (error) {
    console.warn(`Translation key not found: ${textKey}`);
    return textKey; // Devolver la clave original si falla la traducción
  }

  // Reemplazos de formato
  return translatedText
    .replace(/\[br\]/g, '<br>')
    .replace(/\[strong\](.*?)\[\/strong\]/g, '<strong>$1</strong>')
    .replace(/\[link url="(.*?)"\](.*?)\[\/link\]/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$2</a>')
    .replace(/\[nuxtlink url="(.*?)"\](.*?)\[\/nuxtlink\]/g, (match, url, text) => {
      const localLink = localPath ? localPath(url) : url;
      return `<a href="${localLink}">${text}</a>`;
    });
}